import axios from "axios";
const user = JSON.parse(localStorage.getItem("user"));

const initialState = user
    ? {
        status: {
            loggedIn: true
        },
        user
    }
    : {
        status: {
            loggedIn: false
        },
        user: null
    };
export const auth = {
    namespaced: true,
    state: initialState,
    actions:{
        login({commit}, user) {
            return axios.post('v1/auth/login',user).then(
                user => {
                    let usuario = {
                        'company': user.data.company,
                        'token': user.data.token,
                        'kind': user.data.kind
                    }
                    localStorage.setItem("user", JSON.stringify(usuario));
                    axios.defaults.headers.common["Authorization"] = `Token ${usuario.token}`
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure', user);
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
    },
    getters:{

    }
}